// 9fbef606107a605d69c0edbcd8029e5d
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import StyledButton from '../styles/ProductCard.style';

const ProductCard = ({ children, onPress, disabled, showList, showImage, isDimmed }) => {
  const [isPressed, setIsPressed] = useState(false);

  return (
    <StyledButton
      showList={showList && !showImage}
      disabled={showImage || disabled || isDimmed}
      onMouseDown={() => setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      onMouseLeave={() => setIsPressed(false)}
      onTouchStart={(e) => {
        if (disabled) return;
        setIsPressed(true);
        e.stopPropagation();
      }}
      onTouchEnd={() => setIsPressed(false)}
      onClick={onPress}
      isPressed={isPressed}
    >
      {children}
    </StyledButton>
  );
};

ProductCard.propTypes = {
  onPress: PropTypes.func,
  isDimmed: PropTypes.bool,
  disabled: PropTypes.bool,
  showList: PropTypes.bool,
  showImage: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

ProductCard.defaultProps = {
  isDimmed: false,
  disabled: false,
  showList: false,
  showImage: false,
  onPress: () => {},
};

export default React.memo(ProductCard);
